import { StablecoinApprovalDecisionValue, StablecoinTransferCreate, StablecoinTransferListFilter } from '../../models/transfer.model';

export class InitStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] InitStablecoinTransfersState';
}

export class ClearStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] ClearStablecoinTransfersState';
}

export class ResetStablecoinTransfersState {
	static readonly type: string = '[StablecoinTransfers] ResetStablecoinTransfersState';
}

export class GetStablecoinTransfers {
	static readonly type: string = '[StablecoinTransfers] GetStablecoinTransfers';
	/** `silent` refreshes (polling) don't flip the loading flag. */
	constructor(
		public filter?: StablecoinTransferListFilter,
		public cursor?: string,
		public silent?: boolean
	) {}
}

export class GetNeedsApprovalTransfers {
	static readonly type: string = '[StablecoinTransfers] GetNeedsApprovalTransfers';
	constructor(public silent?: boolean) {}
}

export class CreateStablecoinTransfer {
	static readonly type: string = '[StablecoinTransfers] CreateStablecoinTransfer';
	constructor(
		public body: StablecoinTransferCreate,
		public idempotencyKey: string
	) {}
}

export class CancelStablecoinTransfer {
	static readonly type: string = '[StablecoinTransfers] CancelStablecoinTransfer';
	constructor(
		public transferId: string,
		public reason?: string | null
	) {}
}

export class RetryStablecoinTransfer {
	static readonly type: string = '[StablecoinTransfers] RetryStablecoinTransfer';
	constructor(public transferId: string) {}
}

export class BulkDecideStablecoinTransfers {
	static readonly type: string = '[StablecoinTransfers] BulkDecideStablecoinTransfers';
	constructor(
		public transferIds: string[],
		public decision: StablecoinApprovalDecisionValue,
		public comment?: string | null
	) {}
}

export class GetTransferApprovals {
	static readonly type: string = '[StablecoinTransfers] GetTransferApprovals';
	constructor(public transferId: string) {}
}

export class SubmitTransferApproval {
	static readonly type: string = '[StablecoinTransfers] SubmitTransferApproval';
	constructor(
		public transferId: string,
		public decision: StablecoinApprovalDecisionValue,
		public comment?: string
	) {}
}

export class GetStablecoinApprovalPolicy {
	static readonly type: string = '[StablecoinTransfers] GetStablecoinApprovalPolicy';
}

export class ClearStablecoinTransferHold {
	static readonly type: string = '[StablecoinTransfers] ClearStablecoinTransferHold';
	constructor(
		public transferId: string,
		public comment?: string
	) {}
}
